module.exports = __webpack_public_path__ + "img/4.f4b58c94.png";